import React from "react";
import { Modal, ModalHeader, ModalBody, FormGroup, Label, Input, Button, FormFeedback } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

const EditProfileModal = ({ isOpen, toggle, profile, onSubmit }) => {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      first_name: profile?.first_name || "",
      last_name: profile?.last_name || "",
      civility: profile?.civility || "",
      address: profile?.address || "",
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required("Veuillez saisir le prénom"),
      last_name: Yup.string().required("Veuillez saisir le nom"),
      civility: Yup.string().required("Veuillez saisir la civilité"),
      //address: Yup.string().required("Veuillez saisir l'adresse"),
    }),
    onSubmit: (values) => {
      onSubmit(values);
      formik.resetForm();
    },
  });

  return (
    <Modal 
     backdrop={'static'}
    id="staticBackdrop"
    isOpen={isOpen} 
    toggle={toggle} 
    centered
    >
      <ModalHeader toggle={toggle}>Modifier les informations de base</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <FormGroup>
            <Label for="firstName">Prénom</Label>
            <Input
              id="firstName"
              name="first_name"
              type="text"
              placeholder="Prénom"
              value={formik.values.first_name}
              onChange={formik.handleChange}
              invalid={formik.touched.first_name && !!formik.errors.first_name}
            />
            <FormFeedback>{formik.errors.first_name}</FormFeedback>
          </FormGroup>

          <FormGroup>
            <Label for="lastName">Nom</Label>
            <Input
              id="lastName"
              name="last_name"
              type="text"
              placeholder="Nom"
              value={formik.values.last_name}
              onChange={formik.handleChange}
              invalid={formik.touched.last_name && !!formik.errors.last_name}
            />
            <FormFeedback>{formik.errors.last_name}</FormFeedback>
          </FormGroup>

          <FormGroup>
            <Label for="title">Civilité</Label>
            <Input
              id="title"
              name="civility"
              type="select"
              value={formik.values.civility}
              onChange={formik.handleChange}
              invalid={formik.touched.civility && !!formik.errors.civility}
            >
              <option value="">Sélectionner</option>
              <option value="M.">M.</option>
              <option value="Mme">Mme</option>
              <option value="Mlle">Mlle</option>
            </Input>
            <FormFeedback>{formik.errors.civility}</FormFeedback>
          </FormGroup>

          <FormGroup>
            <Label for="address">Adresse</Label>
            <Input
              id="address"
              name="address"
              type="text"
              placeholder="Adresse"
              value={formik.values.address}
              onChange={formik.handleChange}
              invalid={formik.touched.address && !!formik.errors.address}
            />
            <FormFeedback>{formik.errors.address}</FormFeedback>
          </FormGroup>

          <div className="text-end">
            <Button color="secondary" outline onClick={toggle} className="me-2">
              Annuler
            </Button>
            <Button color="primary" type="submit">
              Enregistrer
            </Button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default EditProfileModal;
